import { Loader } from '@driftt/tide-core'
import { Subnav } from '@driftt/tide-subnav'
import React, { lazy, Suspense, useState } from 'react'
import { NavLink, Redirect, Route, Switch } from 'react-router-dom'

import {
  userHasAnyPlaybookAccess,
  userHasContentRecommendations,
  userHasMeetingBookingAppExperience,
  userHasSearchAppExperience,
} from 'utils/access'
import { getSubNavNodes } from 'utils/getSubNavNodes'

const IframeWrapper = lazy(() => import('./IframeWrapper'))

export default function SiteConcierge() {
  const hasAnyPlaybookAccess = userHasAnyPlaybookAccess()
  const hasSiteConciergeExperience = userHasContentRecommendations()
  const hasSiteConciergeSearchApp = userHasSearchAppExperience()
  const hasSiteConciergeMeetingBookingApp = userHasMeetingBookingAppExperience()

  const [sidebarIsOpen, setSidebarIsOpen] = useState(false)

  const SUB_NAV_NODES = getSubNavNodes()

  return (
    <>
      {hasAnyPlaybookAccess && (
        <Subnav
          open={sidebarIsOpen}
          title="Playbooks"
          nodes={SUB_NAV_NODES}
          NavLink={NavLink}
          onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
        />
      )}
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route
            exact
            path="/site-concierge/content-recommendations"
            render={() => (
              <IframeWrapper
                path="content-recommendations"
                show={hasSiteConciergeExperience}
                className="content-recommendations-iframe"
              />
            )}
          />
          <Route
            exact
            path="/site-concierge/meeting-booking"
            render={() => (
              <IframeWrapper
                path="meeting"
                show={hasSiteConciergeMeetingBookingApp}
              />
            )}
          />
          <Route
            exact
            path="/site-concierge/settings"
            render={() => (
              <IframeWrapper
                path="settings"
                show={hasSiteConciergeExperience}
              />
            )}
          />
          <Route
            exact
            path="/site-concierge/search"
            render={() => (
              <IframeWrapper path="search" show={hasSiteConciergeSearchApp} />
            )}
          />
          <Route render={() => <Redirect to="/playbooks" />} />
        </Switch>
      </Suspense>
    </>
  )
}
